module.exports = __webpack_public_path__ + "static/media/mr.38d81da0.svg";